import { __module as t } from "../../../_virtual/isMimeType.js";
import { a as e } from "./util/assertString.js";
Object.defineProperty(a = t.exports, "__esModule", {
  value: !0
}), a.default = function (t) {
  return (0, s.default)(t), r.test(t) || i.test(t) || o.test(t);
}, s = e && e.__esModule ? e : {
  default: e
}, r = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i, i = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i, o = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i, t.exports = a.default, t.exports.default = a.default;
var a,
  s,
  r,
  i,
  o,
  u = t.exports;
export { u as i };